import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import ArrowDownSimple from 'components/icons/iconArrowDownSimple';
import ShowroomLocatorContent from './ShowroomLocatorContent';
const MobileShowroomLocator = () => {
  const $ = _c(14);
  const [isExpanded, setIsExpanded] = useState(false);
  let t0;
  if ($[0] !== isExpanded) {
    t0 = () => {
      setIsExpanded(!isExpanded);
    };
    $[0] = isExpanded;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleExpanded = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "block"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-gray font-bold text-[.78rem]">Location</span>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isExpanded) {
    t3 = !isExpanded ? <IconArrowRightSimple /> : <ArrowDownSimple width={16} height={9} />;
    $[4] = isExpanded;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3 || $[7] !== toggleExpanded) {
    t4 = <button onClick={toggleExpanded} className="w-full flex justify-between items-center px-[3.333vw] py-4 text-left cursor-pointer" type="button">{t2}{t3}</button>;
    $[6] = t3;
    $[7] = toggleExpanded;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isExpanded) {
    t5 = isExpanded && <div className="w-full bg-white"><div className="px-[3.333vw] pb-4"><div className="text-sm text-gray mb-3">Find your closest showroom</div><ShowroomLocatorContent inputId="mobile-showroom-zipcode" className="p-0 bg-transparent" isMobile={true} /></div></div>;
    $[9] = isExpanded;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="w-full border-b border-solid border-gray-light5 bg-white" style={t1}>{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default MobileShowroomLocator;